import _ from 'lodash';
import axios from 'axios';
import Cognito from '../../../../global/js/cognito';

export class AuthenticationUtils {
	constructor() {}

	/**
	 * Login Flow
	 * @param {authenticationDetails} authData
	 * @param {{cognitoUser, userPool, onAuthenticatedSuccess, onAskedToVerify, onError}} options
	 * @returns
	 */
	login(authData, options) {
		options = _.merge({}, options);
		const userPool = options.userPool;
		const cognitoUser = options.cognitoUser;
		const authenticationDetails = authData;

		return this
				.cognitoAuthenticateUser({authenticationDetails, cognitoUser})
				.then((result)=> {
					Cognito.getUserAttributes(userPool)
						.then((userAttrs)=> {
							// Check if email_verified property is existed.
							const emailVerified = _.find(userAttrs, {Name: 'email_verified'});
							if (!emailVerified) return;
							const isEmailVerified = JSON.parse(emailVerified.getValue());
							if (isEmailVerified) {
								// Account has already verified flow
								if (typeof options.onAuthenticatedSuccess === 'function') options.onAuthenticatedSuccess(result);
							} else {
								// Request to verify account
								if (typeof options.onAskedToVerify === 'function') options.onAskedToVerify();
							}
						});
				}, (err)=> {
					if (typeof options.onError === 'function') options.onError(err);
				});
	}

	/**
	 * Authenticate a user to Cognito
	 * @param {{authenticationDetails, cognitoUser}} options
	 * @returns an axios promise
	 */
	cognitoAuthenticateUser(options) {
		options = _.merge({}, options);
		return new Promise((resolve, reject)=> {
			options.cognitoUser.authenticateUser(options.authenticationDetails, {
				onSuccess: function(result) {
					resolve(result);
				},
				onFailure: function(err) {
					reject(err);
				},
			});
		});
	}

	/**
	 *
	 * @param {string} token Token from AWS Cognito
	 * @returns a axios promise
	 */
	signin(token) {
		return axios.post('/api/customer/signin', {token: token});
	}
}
